<ion-app *ngIf="environmentIsReady" class="qvs-app">
  <qvs-no-internet-connection
    class="qvs-app__no-internet-connection-overlay"
    [style.display]="showNoInternetConnectionIndicator ? 'block' : 'none'"
    (closeIndicator)="closeNoInternetConnectionIndicator()"
  >
  </qvs-no-internet-connection>
  <router-outlet></router-outlet>
</ion-app>
